import React, {useEffect, useRef, useState} from "react";
import AjaxButton from "src/shared/form/ajax_button";
import classNames from "classnames";
import _ from "lodash";
import moment from 'moment'
import {useSelector} from "react-redux";
import axios from "axios";
import {setVideoRoom} from "../../../../admin/video_room_manager/reducer";

export default function ChatWindow(props) {
  const {supportChatSession, sendMessageUrl, onSuccessfullySent} = props

  const messageContainer = useRef(null);
  const messageEndRef = useRef(null);
  const sendButton = useRef(null);

  const [currentMessage, setCurrentMessage] = useState("")
  const [keepScrolledBottom, setKeepScrolledBottom] = useState(true);

  const clientReadSupportChatMessageUrl = useSelector(state => state.clientReadSupportChatMessageUrl)
  const supportChatMessages = useSelector((state) => state.supportChatMessages.filter((supportChatMessage) => supportChatMessage.support_chat_session_id === supportChatSession.id))
  const messages = _.sortBy(supportChatMessages, (message) => moment(message.created_at).valueOf())
  const additionalData = props.additionalData || {}
  const [isSendingChatMessage, setIsSendingChatMessage] = useState(false)
  const translations = props.translations || {}

  const scrollToBottom = () => {
    if (keepScrolledBottom && messageContainer.current) {
      messageContainer.current.scrollTop = messageContainer.current.scrollHeight
      // messageEndRef.current.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    }
  }

  const onMessagesScrolled = (event) => {
    setKeepScrolledBottom(event.target.scrollTop + event.target.offsetHeight >= event.target.scrollHeight - 1)
  }

  if (keepScrolledBottom && messageEndRef.current) {
    scrollToBottom()
  }

  const handleChatInput = (event, isSendingChatMessage) => {
    if (event.key === 'Enter' && !event.shiftKey && sendButton.current && event.target.value && !isSendingChatMessage) {
      event.preventDefault()
      event.stopPropagation()
      sendButton.current.click()
    }
  }

  const linkRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
  const renderMessageBody = (body) => {
    return body.split(linkRegex).map((part, index) => {
      return (index % 2 === 0 ? part : <a href={part} target="_blank">{part}</a>)
    })
  }

  const groupMessages = (messages) => {
    let groupedMessages = []
    messages.forEach((message) => {
      let lastMessageGroup = groupedMessages[groupedMessages.length - 1]

      if (lastMessageGroup && lastMessageGroup.written_by_tag_owner == message.written_by_tag_owner) {
        lastMessageGroup.messages = [...lastMessageGroup.messages, message]
      } else {
        groupedMessages = [
          ...groupedMessages,
          {
            written_by_tag_owner: message.written_by_tag_owner,
            messages: [
              message
            ]
          }
        ]
      }
    })

    return groupedMessages
  }

  const groupedMessages = groupMessages(messages)

  useEffect(() => {
    // Without timeout it does not scroll down initially - maybe because the dom is not rendered fully event tough useEffect is executed after the render cycle?
    setTimeout(() => {
      scrollToBottom()
    }, 800)
  }, [])

  useEffect(() => {
    scrollToBottom()
  }, [messages])

  useEffect(() => {
    const unreadSupportChatMessages = supportChatMessages.filter(supportChatMessage => !supportChatMessage.read_by_tag_owner)

    if (clientReadSupportChatMessageUrl && unreadSupportChatMessages.length > 0) {
      const timeout = setTimeout(() => {
        const data = {
          unread_support_chat_message_ids: unreadSupportChatMessages.map(unreadSupportChatMessage => unreadSupportChatMessage.id)
        };

        axios.post(clientReadSupportChatMessageUrl, data)
          .catch((error) => {
            console.error(error)
            alert("Error while updating support chat messages.")
          })
      }, 1500)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [clientReadSupportChatMessageUrl, supportChatMessages])


  return <>
    {messages.length === 0 ? <div style={{flex: 1}} className="col-12">
      <p>
        You currently have no messages in this chat.
      </p>
    </div> : null}
    <div ref={messageContainer}
         onScroll={onMessagesScrolled}
         style={{flex: 1, overflow: "auto"}}
         className="chat-messages styled-scrollbar">
      {groupedMessages.map((groupedMessage, index) => {
        const lastMessage = groupedMessage.messages[groupedMessage.messages.length - 1]
        const createdAt = moment(lastMessage.created_at) > moment() ? moment() : moment(lastMessage.created_at)

        return <div key={lastMessage.id}
                    className={"col-12 px-4" + (lastMessage.written_by_tag_owner ? (props.isTagOwner ? " text-right" : " text-left") : (props.isTagOwner ? " text-left" : " text-right"))}>
          <div>
            <strong>{lastMessage.written_by_tag_owner ? lastMessage.tag_owner_name : lastMessage.account_name}</strong>
            {" "}
            <small style={{color: "#9c9c9c"}}>{createdAt.locale('en').fromNow()}</small>
            <br/>
            {groupedMessage.messages.map(message => {
              return <div key={message.id}>
                {renderMessageBody(message.body)}
                <br/>
              </div>
            })}
          </div>
          {messages.length > index + 1 ? <hr/> : null}
        </div>
      })}
      <div ref={messageEndRef}/>
    </div>
    {(supportChatSession.complete || props.disableInput) ? null :
      <div className="input-group chat-window-input-form-group">
        <input
          className="form-control"
          type="text"
          onKeyDown={(event) => handleChatInput(event, isSendingChatMessage)}
          placeholder={translations?.write_your_message || "Write your message"}
          value={currentMessage}
          onChange={(event) => {
            setCurrentMessage(event.target.value)
          }}
        />
        {currentMessage ? <div className="input-group-append">
          <AjaxButton
            buttonRef={sendButton}
            method="put"
            labelSending={translations?.sending || "Sending ..."}
            setSending={setIsSendingChatMessage}
            className={classNames("btn btn-outline-success btn-ueg btn-ueg-styled")}
            icon="fa-save"
            url={sendMessageUrl}
            data={{
              ...additionalData,
              body: currentMessage,
              support_chat_session_id: supportChatSession.id
            }}
            label={translations?.send || "Send"}
            onSuccess={(data) => {
              if (data.data.status === "OK") {
                setCurrentMessage("")
                onSuccessfullySent ? onSuccessfullySent(data.data.support_chat_message) : null
              } else {
                alert(data.data.message || "A error occurred sending the message.")
              }
            }}
            onError={(error) => {
              console.log(error)
              alert("Error sending chat message", error)
            }}
          />
        </div> : null}
      </div>}
  </>;
}